import React from "react";
import { formatCurrency } from "../../../Utils";

const LineChartHeader = ({
  total,
  colors,
  years,
  data,
  unity,
  showData = false,
  calculationType = "sum", // New prop to choose calculation method
}) => {
  // Helper function to calculate the total or average based on calculationType
  const calculateValue = (yearData) => {
    if (!yearData) return 0;

    if (calculationType === "average") {
      const validData = yearData.filter(
        (val) => val !== null && val !== undefined
      );
      return validData.length > 0
        ? (
            validData.reduce((acc, curr) => acc + curr, 0) / validData.length
          ).toFixed(2)
        : 0;
    }
    // Default to sum
    return yearData.reduce((acc, curr) => acc + curr, 0);
  };

  return (
    <div className="alignH justify-content-between px-5 py-2">
      <div className="alignH gap-4">
        {years?.map((year, index) => {
          const value = calculateValue(data && data[year]);
          return (
            <div className="d-flex" key={year}>
              <div className="alignH gap-2">
                <span
                  className={`br50 bg-${colors[index]}`}
                  style={{ width: "11px", height: "11px" }}
                ></span>
                <span className="br50 text-lightBlack sBold f12">{year}</span>
              </div>
              {showData && (
                <div className="alignH gap-2 ms-1">
                  <span className="br50 text-lightBlack sBold f12">
                    :{" "}
                    {calculationType === "average"
                      ? `${total ? total[year]?.toFixed(2) : 0}% `
                      : value > 0
                      ? unity
                        ? unity === "%"
                          ? value + "%"
                          : formatCurrency(value)
                        : value
                      : 0}
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LineChartHeader;
